import { render, staticRenderFns } from "./SubCompanyList.vue?vue&type=template&id=22e4f29e&scoped=true"
import script from "./SubCompanyList.vue?vue&type=script&lang=js"
export * from "./SubCompanyList.vue?vue&type=script&lang=js"
import style0 from "./SubCompanyList.vue?vue&type=style&index=0&id=22e4f29e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4f29e",
  null
  
)

export default component.exports